<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel" i18n="@@ChangePasswordHeader">Passwort ändern</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">
  <app-message [service]="messageService"></app-message>

  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <div class="mb-2">
      <label id="currentpw" for="currentPassword" i18n="@@CurrentPasswordLabel">Aktuelles Passwort</label>
      <input id="currentPassword" formControlName="currentPassword" name="currentPassword" type="password" class="form-control" placeholder="Aktuelles Passwort" i18n-placeholder="@@CurrentPassword">
      <div class="error">
        <em *ngIf="formService.validateControl('currentPassword') && formService.hasError('currentPassword', 'required')" i18n="@@PasswordRequiredError">Aktuelles Passwort wird benötigt</em>
      </div>
    </div>
    <div class="mb-2">
      <label id="newpw" for="newPassword" i18n="@@NewPasswordLabel">Neues Passwort</label>
      <!-- <input id="newPassword" formControlName="newPassword" name="newPassword" type="password" class="form-control" placeholder="Neues Passwort"> -->
      <input type="password" id="newPassword" formControlName="newPassword" (keyup)="checkPassword($event.target.value)" class="form-control" [ngClass]="{ 'is-invalid': formService.validateControl('newPassword') }" placeholder="Neues Passwort" i18n-placeholder="@@NewPassword"/>
      <div class="error">
        <em *ngIf="formService.validateControl('newPassword') && formService.hasError('newPassword', 'required')"  i18n="@@NewPasswordRequiredError">Neues Passwort wird benötigt</em>
      </div>
      <div class="password-requirements">
        <span [class]="passwordHasUpperCase ? 'check' : ''" i18n="@@CapitalLetterHint">Großbuchstabe</span>
        <span [class]="passwordHasLowerCase ? 'check' : ''" i18n="@@LowercaseLetterHint">Kleinbuchstabe</span>
        <span [class]="passwordHasDigit ? 'check' : ''" i18n="@@DigitHint">Ziffer</span>
        <span [class]="passwordHasLength ? 'check' : ''" i18n="@@10CharactersLongHint">10 Zeichen lang</span>
        <span *ngIf="passwordHasSpecialCharacter"
                [class]="passwordHasSpecialCharacter ? 'check' : ''" i18n="@@SpecialCharacterHint">Sonderzeichen</span>
      </div>
    </div>
    <div class="mb-2">
      <label id="newpwc" for="newPasswordConfirm" i18n="@@ConfirmNewPasswordLabel">Neues Passwort wiederholen</label>
      <input id="newPasswordConfirm" formControlName="newPasswordConfirm" name="newPasswordConfirm" type="password" class="form-control" placeholder="Neues Passwort wiederholen" i18n-placeholder="@@RepeatNewPassword">
      <div class="error">
        <em *ngIf="formService.validateControl('newPasswordConfirm') && formService.hasError('newPasswordConfirm', 'required')"  i18n="@@ConfirmNewPasswordRequiredError">Neues Passwort muss wiederholt werden</em>
        <em *ngIf="formService.hasError('newPasswordConfirm', 'mustMatch')" i18n="@@PasswordsNotIdenticError">Passwörter müssen übereinstimmen</em>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" data-bs-dismiss="modal" i18n="@@CancelButton">Abbrechen</button>
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
    <button type="submit" id="confirm" class="btn btn-yellow" [disabled]="!formService.form.valid" i18n="@@SavePasswordButton">Passwort ändern</button>
  </form>
</div>
